import React from 'react'
import * as S from './Header.styles'
import SupportSvg from 'assets/images/support.svg'
import bannerEN from 'assets/images/Header/banner-en.png'
import bannerPT from 'assets/images/Header/banner-pt.png'
import bannerMobileEN from 'assets/images/Header/banner-mobile-en.png'
import bannerMobilePT from 'assets/images/Header/banner-mobile-pt.png'
import { useIntl } from 'gatsby-plugin-intl'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { useZendesk } from 'hooks/useZendesk'
import useCountdownFrom from 'hooks/useCountdownFrom'

const Header = () => {
  const handlerSupport = useZendesk()
  const { formatMessage, locale } = useIntl()
  const { width, height } = useWindowDimensions()
  const { countdown, isCounting } = useCountdownFrom(
    'Jun 8, 2021 08:00:00 GMT-03:00'
  )

  return (
    <S.Hero height={height}>
      <S.Wrapper>
        <S.Content>
          <S.ImageWrapper>
            {width > 768 ? (
              <S.Banner src={locale === 'en' ? bannerEN : bannerPT} />
            ) : (
              <S.Banner
                src={locale === 'en' ? bannerMobileEN : bannerMobilePT}
              />
            )}
          </S.ImageWrapper>
            <S.DateWrapper show={isCounting}>
              <S.DateUnit>
                <S.Date>{countdown.days}</S.Date>
                <S.DateLabels>
                  {formatMessage({ id: 'header.unit.day' })}
                </S.DateLabels>
              </S.DateUnit>
              <S.DateUnit>
                <S.Date> {countdown.hours}</S.Date>
                <S.DateLabels>
                  {formatMessage({ id: 'header.unit.hour' })}
                </S.DateLabels>
              </S.DateUnit>
              <S.DateDot>:</S.DateDot>
              <S.DateUnit>
                <S.Date>{countdown.minutes}</S.Date>
                <S.DateLabels>
                  {formatMessage({ id: 'header.unit.minute' })}
                </S.DateLabels>
              </S.DateUnit>
              <S.DateDot>:</S.DateDot>
              <S.DateUnit>
                <S.Date>{countdown.seconds}</S.Date>
                <S.DateLabels>
                  {formatMessage({ id: 'header.unit.second' })}
                </S.DateLabels>
              </S.DateUnit>
            </S.DateWrapper>
          <S.Button>
            <S.Link href={`https://plataforma.vpsvale.com/`} />
            {formatMessage({ id: 'header.button' })}
          </S.Button>
        </S.Content>
      </S.Wrapper>
    </S.Hero>
  )
}

export default Header
